<head>
  <meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<div class="container d-flex justify-content-center">

</div>
<nav class="navbar navbar-expand-lg navbar-light bg-light" style="background-color: #e3f2fd;">
  <img src="../../assets/whittlegroup.png" id="logo" (click)="redirectToHome()" class="img-fluid logoWidth" />
  <!--<a class="navbar-brand" routerLink="/dashboard">
  iConnect
</a>-->
<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
  <span class="navbar-toggler-icon"></span>
</button>
<div class="collapse navbar-collapse" id="navbarNavAltMarkup">
  <div class="navbar-nav">
    <a class="nav-item nav-link active" routerLink="/dashboard">Home</a>
    @if (isAdminUser || isTenantUser) {
      <a class="nav-item nav-link" routerLink="/tenants">Tenants</a>
    }
    @if (isAdminUser || isTenantUser) {
      <a class="nav-item nav-link" routerLink="/api-clients">API-Clients</a>
    }
    @if (isAdminUser || isTenantUser) {
      <a class="nav-item nav-link" href="/assets/docs-tenants.html" target="_blank">Transactions API</a>
    }

  </div>
</div>

<ul class="nav navbar-nav navbar-right me-5">
  <li class="dropdown">
    <a class="dropdown-toggle nav-item nav-link active" data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{userName}}<span class="caret"></span></a>
    <ul class="dropdown-menu">
      <li class="nav-item nav-link active">Logged in as {{loginType}}</li>
      <li><a class="nav-item nav-link active" routerLink="/updatePassword" [queryParams]="{action: 'change'}">Change Password</a></li>
      <li><a class="nav-item nav-link active" routerLink="/logout">Logout</a></li>
    </ul>
  </li>

</ul>
</nav>
